import axios from 'axios';
import APIURL from '../common/Config';

const ApiManagerCustomer = {
  fetchCustomerAccountDetails: async (msisdn) => {
    try {
      const response = await axios.get(`${APIURL}/astroservice/login/ascustomer/${msisdn}`);
      await ApiManagerCustomer.storeData('customerId', response.data.id);

      if (response.data && response.data.id > 0) {
        return {
          status: 1,
          errorMsg: "Customer Record Found",
          id: response.data.id,
          customerName: response.data.customerName,
          msisdn: response.data.msisdn,
        };
      } else {
        console.error('Error response Login Customer Data', response.data);
        return {
          status: 0,
          errorMsg: "Customer Record not found",
          id: 0,
          customerName: "",
          msisdn: msisdn,
        };
      }
    } catch (error) {
      console.error('Error:', error.message);
      return {
        status: -1,
        errorMsg: error.message,
        id: 0,
        customerName: "",
        msisdn: msisdn,
      };
    }
  },

  registerAsCustomer: async (customerDetails) => {
    try {
      const response = await axios.post(`${APIURL}/astroservice/register/customer`, customerDetails);
      if (response.data && response.data.id) {
        await ApiManagerCustomer.storeData('customerId', response.data.id);
      }
      return response.data;
    } catch (error) {
      console.error('Error registering customer:', error.message);
      throw error;
    }
  },

  storeData: async (key, value) => {
    try {
      const jsonValue = JSON.stringify(value);
      localStorage.setItem(key, jsonValue);
      console.log(`Data successfully saved under key "${key}"!`);
    } catch (error) {
      console.error('Error storing data:', error);
    }
  },

  getData: async (key) => {
    try {
      const jsonValue = localStorage.getItem(key);
      return jsonValue != null ? JSON.parse(jsonValue) : null;
    } catch (error) {
      console.error('Error retrieving data:', error);
      return null;
    }
  },

  initiateCustomerRegistrationData: (msisdn) => ({
    status: -1,
    errorMsg: "",
    id: 0,
    customerName: "",
    msisdn: msisdn,
    firstName: "",
    lastName: "",
    gender: "M",
    dob: "",
    timeOfBirth: null,
    mobile: "",
    email: "NA",
    socialmedia: 0,
    birthCity: "",
    longitude: "",
    latitude: "",
    regDate: "",
    lastUpdate: "",
    lastCallTime: "",
    lastAstrologerId: 0,
    balanceAmount: 0,
    allowFreeChat: 1,
    birthState: "",
    birthPlace: "",
    country: "",
    pinCode: 0,
    statusDescp: "",
    appName:'AstrBhagya2026'
  }),
};

export default ApiManagerCustomer;
